import { useQuery } from '@tanstack/react-query';

// common
import { KEYS_QUERY } from 'common/constants';
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { AccessStatisticsResponse } from 'modules/dashboard/types';

interface Props {
  /** `YYYY-MM`. Bỏ trống → không gọi API. */
  monthKey?: string;
  enabled?: boolean;
}

/**
 * Thống kê lượt truy cập hệ thống của một tháng. Khách vãng lai cũng gọi được (BE đã mở trong
 * allowlist), nên KHÔNG chặn theo tài khoản ở đây.
 */
const useAccessStatistics = ({ monthKey, enabled = true }: Props) => {
  const service = useService();

  return useQuery({
    queryKey: [KEYS_QUERY.accessStatistics, monthKey],
    queryFn: async (): Promise<AccessStatisticsResponse | null> => {
      try {
        if (!service || !monthKey) return null;
        return await service.DashboardController_getAccessStatistics({
          queries: { month_key: monthKey },
        });
      } catch (error) {
        handleException(error);
        return null;
      }
    },
    enabled: !!service && !!monthKey && enabled,
  });
};

export default useAccessStatistics;
